import { ReactNode } from 'react';
import { CheckboxVariant, VisualAsset } from 'core/flow/entities';
import { getVisualAssetImageSrc } from '../VisualAssetImage';
import { CheckboxCard } from './CheckboxCard';
import { CheckboxImage } from './CheckboxImage';
import { CheckboxOption } from './CheckboxOption';

type AnswerCheckboxProps = {
  checked: boolean;
  value: string;
  image?: VisualAsset;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
  variant?: CheckboxVariant;
  disabled?: boolean;
};

export const AnswerCheckbox = ({
  children,
  checked,
  onAnswerClick,
  value,
  image,
  variant = CheckboxVariant.OPTION,
  disabled,
  ...otherProps
}: AnswerCheckboxProps) => {
  const getCheckbox = (type: CheckboxVariant) => {
    if (type === CheckboxVariant.IMAGE) {
      return (
        <CheckboxImage
          imageSrc={getVisualAssetImageSrc(image)}
          value={value}
          checked={checked}
          onAnswerClick={onAnswerClick}
          disabled={disabled}
          {...otherProps}
        >
          {children}
        </CheckboxImage>
      );
    }

    if (type === CheckboxVariant.CARD) {
      return (
        <CheckboxCard
          image={image}
          value={value}
          checked={checked}
          onAnswerClick={onAnswerClick}
          disabled={disabled}
          {...otherProps}
        >
          {children}
        </CheckboxCard>
      );
    }

    return (
      <CheckboxOption
        image={image}
        value={value}
        checked={checked}
        onAnswerClick={onAnswerClick}
        disabled={disabled}
        {...otherProps}
      >
        {children}
      </CheckboxOption>
    );
  };

  return <>{getCheckbox(variant)}</>;
};
